(function($) {
  'use strict';
  Foundation.Drilldown.defaults.backButton = '<li class="js-drilldown-back"><a>Zur Übersicht</a></li>';

  // logic to set height of repositioned header search form for < large based on equalizer
  var setHeaderSearchFormHeight = function ($element) {

    var height = $element.find('[data-equalizer-watch]').first().outerHeight();

    if ( Foundation.MediaQuery.atLeast('large') ) {
      // ugly hack to overwrite equalizer heights for large as well, since we now use a tooltip for search button
      var header_teaser_height = $('.header-sub').find('[data-equalizer-watch]').first().outerHeight(),
          submit_button_height = $('.header-sub .search-form .search-submit').outerHeight();

      //console.log('teaser: ' + header_teaser_height);
      //console.log('button: ' + submit_button_height);
      if(header_teaser_height > submit_button_height) {
        $('.header-sub .search-form .search-submit').outerHeight(header_teaser_height);
      }
      return;
    }

    if( height === undefined ) {
      return;
    }

    $('.header-sub .search-form .search-button-tooltip, .header-sub .search-form .search-submit, .header-sub .search-form, .header-sub .search-form .search-field').outerHeight(height);

  };


  var headerfont = new FontFaceObserver('Arvo Gruen');
  var subheaderfont = new FontFaceObserver('Arvo Regular');
  var bodyfont = new FontFaceObserver('PT Sans');

  Promise.all([headerfont.load(), subheaderfont.load()]).then(function () {

    // reflow all equalizer instances after loading fonts
    $('[data-equalizer]').foundation('_reflow');

    // make sure searchform button height is adjusted again
    setHeaderSearchFormHeight( $('.header-events') );

    // relayout isotope, if it's initialized before fonts are loaded
    var iso_instance = Isotope.data( $('[data-isotope]')[0]);
    if(iso_instance !== undefined)
      $('[data-isotope]').isotope('layout');

    //console.log('Headerfont & Subheaderfont have loaded');
  });


  // make sure this event callback is placed before initializing foundation
  /*$('.header-events').on('init.zf.equalizer', function (e) {

    setHeaderSearchFormHeight( $(this) );

    $(this).css({'visibility': 'visible'});

  });*/

  $(window).on('load', function () {
    // fix equalizer issue on safari
    $('[data-equalizer]').foundation('_reflow');
  });

  /**
   * FacetWP Stuff
   */
  $(function() {

    if (typeof FWP !== 'object')
      return;
    //FWP.auto_refresh = false;

    var $fwp_el = $('.facetwp-template'),
        $reset_button_container = $('.facetwp-reset-button-container'),
        disable_button = true,
        LAST_FACETWP_CHECKED = null;

    /*FWP.loading_handler = function(params) {

      //console.log(FWP.loaded);

      //params.element.find('.facetwp-checkbox').addClass('disabled');
      $reset_button_container.find('.search-filter-loader').show();

    };*/

    $(document).on('facetwp-refresh', function(e) {

        // add content overlay
        $fwp_el.prepend('<div class="facetwp-overlay">');
        $fwp_el.find('.facetwp-overlay').css({
            width: $fwp_el.width(),
            height: $fwp_el.height()
        });

        // disable reset button on every refresh
        $reset_button_container.find('button').prop('disabled', true);

        // show loading animation
        $reset_button_container.find('.search-filter-loader').show();
        
        if(FWP.soft_refresh) {
          // Scroll to the top of the page after the page is refreshed
          $('html, body').animate({ scrollTop: 0 }, 250);
        }

    });

    $(document).on('facetwp-loaded', function(e) {

      var is_paginated_only = (Object.keys(FWP_HTTP.url_vars).length === 1 && Object.keys(FWP_HTTP.url_vars)[0] === 'paged');
      //console.log("is paginated view: " + is_paginated_only);

      // hide loading indicator
      $reset_button_container.find('.search-filter-loader').hide();

      // remove content overlay
      $fwp_el.find('.facetwp-overlay').remove();

      // dicide, if reset button should be enabled
      disable_button = true;

      $.each( FWP.facets, function(key, value) {

        // omit 'paged' value
        if(key === 'paged')
          return;

        if (value.length !== 0)
          disable_button = false;

      });

      // enable reset button, if has active filters on initial load and is not a paginated view w/o active filters
      if( (!FWP.loaded && Object.keys(FWP_HTTP.url_vars).length && !is_paginated_only) &&
          (FWP.loaded && !is_paginated_only)
        ) {
        disable_button = false;
      }

      // set button state
      $reset_button_container.find('button').prop('disabled', disable_button);

      /**
      * accessibility improvements
      * see https://gist.github.com/mgibbs189/36e1dd9fbd0c42e0fa9e9911d5b44cb7
      */
      // filter checkboxes
      $('.facetwp-checkbox').each(function() {
        $(this).attr('role', 'checkbox');
        $(this).attr('aria-checked', $(this).hasClass('checked') ? 'true' : 'false');
        $(this).attr('tabindex', 0);

        $(this).bind( 'keydown', function( e ) {
          if( e.keyCode == 32 || e.keyCode == 13 ) {
            e.stopPropagation();
            e.preventDefault();

            LAST_FACETWP_CHECKED = $(this).data( 'value' );

            $(this).click();
          }
        });
      });

      // pagination
      $('.facetwp-page').each(function() {
        $(this).attr('tabindex', 0);
        $(this).bind( 'keydown', function( e ) {

        if( e.keyCode == 13 ) {
          e.stopPropagation();
          e.preventDefault();

          $(this).click();
        }

        });
      });

      if ( LAST_FACETWP_CHECKED !== null ) {
        $( '[data-value="' + LAST_FACETWP_CHECKED + '"]' ).focus();
      }

    });

  });


  $(document).foundation();

  // Fire on document ready.
  $( document ).ready( function () {

    if( typeof tns === 'function' && $('.slider-container').length ) {
      var slider = tns({
        container: '.slider-container',
        items: 1,
        controls: true,
        controlsPosition: 'bottom',
        controlsContainer: '.slider-controls',
        nav: false,
        slideBy: 'page',
        autoplay: false,
        mouseDrag: true,
        //arrowKeys: true,
        gutter: 10,
        autoHeight: true,
        responsive: {
          640: {
            items: 2,
            //controls: true,
          },
          1024: {
            items: 3,
            autoHeight: false,
          }
        }
      });
    }

    /*$('.header-events').on('postequalized.zf.equalizer', function (e) {

      setHeaderSearchFormHeight( $(this) );

    });*/

    var drilldownHeight;
    $('#header-dropdown-wrapper .title-bar').on('toggled.zf.responsiveToggle', function(e) {

      // adjust height of drilldownMenu wrapper to height of active submenu
      if( $('#main-menu').is(':visible') && $('.is-drilldown-submenu.is-active').length ) {

        drilldownHeight = $('.is-drilldown').css('minHeight');

        var subHeight = $('#main-menu .is-drilldown-submenu.is-active').innerHeight();
        $('.is-drilldown').css({'minHeight': 'auto'}).outerHeight(subHeight);

      }

      // we could alternatively hide currently active submenu on menu toggle
      //$('.is-drilldown-submenu.is-active').removeClass('is-active');

    });

    // Patch for a Bug in v6.3.1
    $(window).on('changed.zf.mediaquery', function() {
      if ( ! Foundation.MediaQuery.atLeast('large') ) {
        $('.is-drilldown-submenu').removeClass('is-dropdown-submenu');
      }
      $('.is-drilldown-submenu.invisible').removeClass('invisible');
    });


    // adjust intrinsic image ratio for lazy loaded and interchanged frontpage images
    /*var $frontpage_card_image_containers = $('.home .single-featured-image-header');

    $frontpage_card_image_containers.on('replaced.zf.interchange', 'img', function (e) {
      // set image ratio data attribute depending on current breakpoint
      var imageRatio = 'imageRatio';
      if(Foundation.MediaQuery.atLeast('large')) {
        imageRatio = 'imageRatioLarge';
      }
      $frontpage_card_image_containers.each( function (i, el) {
        if($(el).data(imageRatio) !== undefined) {
          $(el).css({'padding-bottom' : $(el).data(imageRatio)+'%'});
        }
      });
    });

    // change intrinsic image ratio, if breakpoint is at least 'large' on init

      if (Foundation.MediaQuery.atLeast('large')) {
        //console.log('at least large');

        $frontpage_card_image_containers.each( function (i, el) {
          if($(el).data('imageRatioLarge') !== undefined) {
            $(el).css({'padding-bottom' : $(el).data('imageRatioLarge')+'%'});
          }
        });

      }
    */
    // SVG to PNG fallback - maybe use Modernizr or svgxuse script
    /*if (!Modernizr.svg) {
      var imgs = document.getElementsByTagName('img'),
          svgExtension = /.*\.svg$/,
          l = imgs.length;

      for(var i = 0; i < l; i++) {
        if(imgs[i].src.match(svgExtension)) {
          imgs[i].src = imgs[i].src.slice(0, -3) + 'png';
          console.log(imgs[i].src);
        }
      }
    }*/

    /* Change min-height of gfields on form error */
    var hasError = $('.gform_body').find('.gfield_error');
    if($(hasError).size() > 0){
      $('.gform_body .gfield').css('min-height', '100px');
    }

    // data tables init
    if(typeof $.fn.DataTable === 'function') {
      var associationTable = $('.data-table').DataTable( {
        scrollX: true,
        paging: false,
        info: false,
        language: {
          url: script_options.site_url + "/wp-content/themes/gruene/js/datatables.german.json"
        },
        "columns": [
          null,
          { "orderable": false }
        ]
        /*fixedHeader: {
          footer: true
        },*/
        // maybe use responsive settings instead of scrollX
        /*responsive: {
          details: {
            type: 'column',
            target: -1
            //display: $.fn.dataTable.Responsive.display.childRowImmediate
          }
        },
        columnDefs: [ {
            className: 'control',
            orderable: false,
            targets:   -1
        } ],*/
        //order: [ 1, 'asc' ],
      } );
    }


    $('.entry-content').on( 'keyup', '.dataTables_filter input[type="search"]', function(e) {

      //console.log($(this).val().length);
      if( $('.district-association-table tbody tr').length > 5 ) {
        // reset all lists if search value is unspecific
        $('.local-associations-list').each(function(i, el) {
          if( !$(el).hasClass('is-hidden') )
            $(el).parent().find('.local-associations-list-toggle').trigger('click');
        });
      } else if($(this).val().length > 0) {
        // open association lists on active search
        $('.local-associations-list').each(function(i, el) {
          if( $(el).hasClass('is-hidden') )
            $(el).parent().find('.local-associations-list-toggle').trigger('click');
        });
      } else {
        // close any open lists
        $('.local-associations-list').each(function(i, el) {
          if( !$(el).hasClass('is-hidden') )
            $(el).parent().find('.local-associations-list-toggle').trigger('click');
        });
      }

    });

    // change icon for association list toggle
    $('.local-associations-list').on('on.zf.toggler', function(e) {
      $(this).parent().find('.local-associations-list-toggle').removeClass('active');
      $(this).parent().find('.local-associations-list-toggle i.fal').removeClass('fa-minus-circle').addClass('fa-plus-circle');
    });

    $('.local-associations-list').on('off.zf.toggler', function(e) {
      $(this).parent().find('.local-associations-list-toggle').addClass('active');
      $(this).parent().find('.local-associations-list-toggle i.fal').removeClass('fa-plus-circle').addClass('fa-minus-circle');
    });

    // show/hide disruptor image over frontpage teaser video
    $('.frontpage-main-video video').on('play', function () {
      $('.main-disruptor-wrapper').fadeOut();
    });

    $('.frontpage-main-video video').on('seeking', function () {
      $('.main-disruptor-wrapper').hide();
    });

    $('.frontpage-main-video video').on('pause', function () {
      $('.main-disruptor-wrapper').fadeIn();
    });

    $('.frontpage-main-video video').on('ended', function () {
      $('.main-disruptor-wrapper').fadeIn();
    });


  });

})( jQuery );
